import React from 'react'
import { withStyles, withTheme } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import * as PropTypes from 'prop-types'
import clsx from 'clsx'
import { ideaStatusTypeMapper } from 'pages/idea/detail/Constants'
import styles from './View.style'

const IdeaStatusStep = props => {
  const {
    classes,
    icon,
    mainCircleValue,
    secondaryCircleValue,
    text,
    mainColor,
    secondaryColor,
    statusType,
    theme,
  } = props

  const mainDefaultColor = mainColor || theme.palette.primary.main
  const secondaryDefaultColor = secondaryColor || theme.palette.secondary.main

  return (
    <div
      className={clsx(
        classes.statusItems,
        statusType === ideaStatusTypeMapper.next && classes.disabledStatus,
      )}
    >
      <div
        className={clsx(
          classes.iconContainer,
          statusType === ideaStatusTypeMapper.next && classes.iconContainerNext,
        )}
      >
        <span className={`${classes.iconsStyles} ${icon}`} />
        <div className={classes.primaryProgressContainer}>
          <CircularProgress
            thickness={4}
            variant="determinate"
            size={40}
            value={mainCircleValue}
            style={{
              color: `${statusType === ideaStatusTypeMapper.next ? '#333333' : mainDefaultColor}`,
            }}
          />
        </div>
        <div className={classes.secondaryProgressContainer}>
          <CircularProgress
            variant="determinate"
            size={30}
            value={secondaryCircleValue}
            style={{
              color: `${statusType === ideaStatusTypeMapper.next ? '#333333' : secondaryDefaultColor
                }`,
            }}
          />
        </div>
      </div>
      <div
        className={clsx(
          classes.textContainer,
          statusType === ideaStatusTypeMapper.next && classes.textContainerNext,
          statusType === ideaStatusTypeMapper.previous && classes.textContainerPrevious,
        )}
      >
        <span>{text}</span>
      </div>
    </div>
  )
}

IdeaStatusStep.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  mainCircleValue: PropTypes.number.isRequired,
  secondaryCircleValue: PropTypes.number,
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  statusType: PropTypes.oneOf([
    ideaStatusTypeMapper.previous,
    ideaStatusTypeMapper.current,
    ideaStatusTypeMapper.next,
  ]).isRequired,
}

IdeaStatusStep.defaultProps = {
  secondaryCircleValue: 0,
  mainColor: '',
  secondaryColor: '',
}

export default withTheme(withStyles(styles)(IdeaStatusStep))
